export enum VehiclesActions {
    SET_SELECTED_VEHICLES = "setSelectedVehicles",
    SET_ACTIVE_VEHICLE = "setActiveVehicle",
    RELOAD_VEHICLES = "reloadVehicles",
    TOGGLE_VEHICLE_PANEL = "toggleVehiclePanel",
    ADD_VEHICLE = "addVehicle"
  }